import React from 'react';
import { useNavigate } from 'react-router-dom';
import mainlogo from '../../assets/images/main-logo.svg';
import CurrencySelector from '../CurrencySelector/CurrencySelector';
import footerillustration from '../../assets/images/footer-illustration.svg';


const Footer = () => {
    const navigate = useNavigate();

    return (
        <footer className="cyhno">
            {/* Bg */}
            <div className="cbnx3 cx5bd ctehq cakxp" aria-hidden="true" />
            {/* Illustration */}
            <div className="cistn c89jy cfhlr cx5bd c66ts cakxp" aria-hidden="true">
                <img className="cs15f" src={footerillustration} width={1940} height={381} />
            </div>
            <div className="cl9ye cc8xx cdcfy chlof">
                {/* Blocks */}
                <div className="c0eux cfmkg cjqk8 ce1n8 caln0 cavbd c8seb">
                    {/* 1st block */}
                    <div className="cgxv8 c8s3r cz4nm">
                        {/* Logo */}
                        <a className="c4ozt" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} aria-label="Logo">
                            <img src={mainlogo} width={45} height={45} alt="Logo" />
                        </a>
                    </div>
                    {/* 2nd block */}
                    <div className="c58a0 clnng c8s3r">
                        <h6 className="c9gu4 cdxpy c62tk czmmv">Menu</h6>
                        <ul className="c1cp2 cjbs3 c62tk">
                            <li>
                                <a className="c9chn cwiv0 cgdcn cw78b c9pj3" href="#">Home</a>
                            </li>
                            <li>
                                <a className="c9chn cwiv0 cgdcn cw78b c9pj3" href="#perks">Perks</a>
                            </li>
                            <li>
                                <a className="c9chn cwiv0 cgdcn cw78b c9pj3 cpointer" href="#about">About us</a>
                            </li>
                            <li>
                                <a
                                    className="c9chn cwiv0 cgdcn cw78b c9pj3"
                                    onClick={() => navigate('/contact')}

                                >
                                    Contact us
                                </a>
                            </li>
                            <li>
                                <a className="c9chn cwiv0 cgdcn cw78b c9pj3" href="#pricing">Pricing</a>
                            </li>
                            <li>
                                <a className="c9chn cwiv0 cgdcn cw78b c9pj3" href="#faq">FAQ</a>
                            </li>
                        </ul>
                    </div>
                    {/* 3rd block */}
                    <div className="c58a0 clnng c8s3r">
                        <h6 className="c9gu4 cdxpy c62tk czmmv">Contact</h6>
                        <ul className="c1cp2 cjbs3 c62tk">
                            <li>
                                <a className="c9chn cwiv0 cgdcn cw78b c9pj3" href="#" target="_blank">contact@crafmystore.com</a>
                            </li>
                            <li>
                                <a className="c9chn cwiv0 cgdcn cw78b c9pj3" href="#" target="_blank">+91
                                    7718837352</a>
                            </li>
                            <li>
                                <a className="c9chn cwiv0 cgdcn cw78b c9pj3" target="_blank" href="#">WHATSAPP
                                    NOW</a>
                            </li>
                        </ul>
                    </div>
                    {/* 4th block */}
                    <div className="c58a0 clnng c8s3r">
                        <h6 className="c9gu4 cdxpy c62tk czmmv">Address</h6>
                        <ul className="c1cp2 cjbs3 c62tk">
                            <li>
                                <a className="c9chn cwiv0 cgdcn cw78b c9pj3" href="#" target="_blank">T6 , Quality Homes
                                    Thane Lodha
                                    Crown,
                                    Near Majiwada Flyover THANE, MAHARASHTRA, INDIA </a>
                            </li>
                        </ul>
                    </div>
                    {/* 5th block */}
                    <div className="c58a0 clnng c8s3r">
                        <h6 className="c9gu4 cdxpy c62tk czmmv">Legal</h6>
                        <ul className="c1cp2 cjbs3 c62tk">
                            <li>
                                <a
                                    className="c9chn cwiv0 cgdcn cw78b c9pj3 cpointer"
                                    onClick={() => {
                                        navigate('/terms-condition');
                                        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                                    }}
                                >
                                    Terms and Conditions
                                </a>
                            </li>
                            <li>
                                <a
                                    className="c9chn cwiv0 cgdcn cw78b c9pj3 cpointer"
                                    onClick={() => {
                                        navigate('/privacy-policy');
                                        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                                    }}
                                >
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <a
                                    className="c9chn cwiv0 cgdcn cw78b c9pj3 cpointer"
                                    onClick={() => {
                                        navigate('/cancellation-and-refunds-policy');
                                        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                                    }}
                                >
                                    Cancellation and Refunds
                                </a>
                            </li>
                            <li>
                                <a
                                    className="c9chn cwiv0 cgdcn cw78b c9pj3 cpointer"
                                    onClick={() => {
                                        navigate('/shipping-and-delivery-policy');
                                        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                                    }}
                                >
                                    Shipping and Delivery
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* Bottom area */}
                <div className="ce763 cyvm8">
                    <div className="flex justify-between items-center">
                        <div className="c3z20 cwyp8">
                            © Copyrighted 2025 | <a className="c9chn cgdcn cj88f cw78b c9pj3" href="#" target="_blank">Teraforge Digital Lab LLP</a>
                        </div>
                        <CurrencySelector />
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;



